import Cookies from "js-cookie";
import {
  invokeRNMessage,
  INVOKE_ALREADY_GUIDED,
  isNativeApp,
} from "src/utils/nativeUtils";
import { store } from "src/store/configureStore";
import * as TH from "src/store/user/thunks";
import { WizardModes } from ".";
import { YEAR_EXPIRATION_DATE } from "./constants";

const postUserAcceptGuide = () => store.dispatch(TH.postUserAcceptGuideThunk());

export const acceptGuide = (wizardMode: WizardModes) => {
  if (wizardMode === WizardModes.ADMIN)
    Cookies.set("AdminGuided", "administrator took a guide", {
      expires: YEAR_EXPIRATION_DATE,
    });
  if (wizardMode === WizardModes.USER) postUserAcceptGuide();
  if (wizardMode === WizardModes.MOBILE) {
    if (isNativeApp()) {
      invokeRNMessage(INVOKE_ALREADY_GUIDED, true);
    }
    postUserAcceptGuide();
  }
};
